import React from "react";
import { useLocation } from "react-router-dom";
import CodisDNADetailInfo from "../../components/Detail/_CodisDNADetailInfo";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}


function CodisDNADetail() {
    let query = useQuery();

    return (
        <div>
            <CodisDNADetailInfo ID={query.get("ID")} department={query.get("Dept")} />
        </div>
    );
}

export default CodisDNADetail;